export function bodyLockToggle() {
    let doc = document.documentElement;
    let docBody = document.body;
    if (!docBody.classList.contains('fixed')) {
        docBody.style.top = `-${window.scrollY}px`;
        docBody.classList.toggle('fixed');
    } else {
        const scrollYPosition = docBody.style.top;
        docBody.style.top = '';
        docBody.classList.toggle('fixed');
        doc.style.scrollBehavior = 'auto';
        window.scrollTo(0, parseInt(scrollYPosition || '0') * -1);
        doc.style.scrollBehavior = 'smooth';
    }
}